module.exports = __webpack_public_path__ + "img/gur_klavim_yes.7f840a0f.png";